import _ from 'underscore';
import {connect} from 'react-redux';
import {withRouter} from '../utils/routerCompat';
import AuctioneerList from '../components/AuctioneerList/AuctioneerList';
import {
    prepareAuctioneers,
    prefetchAuctioneersPage,
    setLastListUrl
} from '../ducks';
import {
    getTransform,
    OBJECT_AUCTIONEER,
    OBJECT_PAGINATED_LIST
} from '../utils/sources';
import {getFilterParamsFromMatch} from '../utils/auctioneer';
import {getAuctioneerListUrl} from '../utils/urls';

export default withRouter(connect(
    (state, {match}) => {
        let transformAuctioneer = getTransform(OBJECT_AUCTIONEER);
        let transformPaginatedList = getTransform(OBJECT_PAGINATED_LIST);
        let {items: auctioneers} = transformPaginatedList(state.auctioneers.data) || {};
        let {
            association: selectedAssociation,
        } = getFilterParamsFromMatch(match) || {};

        return {
            selectedAssociation,
            auctioneers: _(auctioneers).map(transformAuctioneer),
            auctioneersLoading: state.auctioneers.loading,
            hideAssociationFilter: !!state.associationState,
        };
    },
    (dispatch, {history, match}) => ({
        loadData: () => {
            let {page, search, association} = getFilterParamsFromMatch(match);

            dispatch(prepareAuctioneers(page, undefined, search, association));
            dispatch(setLastListUrl(getAuctioneerListUrl(page, undefined, search, association)));
        },
        prefetchPage: (page, expertise, search, association) => {
            dispatch(prefetchAuctioneersPage(page, expertise, search, association));
        },
        onAssociationChange: (association) => {
            let {search} = getFilterParamsFromMatch(match);

            history.push(getAuctioneerListUrl(1, undefined, search, association));
        },
        onSearchChange: (search, shouldReplace) => {
            let {association} = getFilterParamsFromMatch(match);

            if (search) {
                search = encodeURIComponent(search);
            }

            let method = shouldReplace ? 'replace' : 'push';

            history[method](
                getAuctioneerListUrl(1, undefined, search, association)
            );
        }
    })
)(AuctioneerList));
